module.exports = __webpack_public_path__ + "static/media/music-alt-slash.5468ebf6.svg";